<app-container-header>
  <!-- Content Main -->
  <div
    contentMain
    class="d-flex flex-column box-sizing-border-box grid-container"
  >
    <app-progress-spinner
      color="primary"
      [diameter]="40"
      *ngIf="loading; else showGrid"
    ></app-progress-spinner>
    <ng-template #showGrid>
      <app-grid-list
        minColWidth="300px"
        rowHeight="auto"
        gutterSize="24px"
        class="flex-fill main-grid"
      >
        <app-grid-tile *ngFor="let card of cards | async; trackBy: trackByLink">
          <app-card variant="tight" [routerLink]="card.link">
            <div
              class="d-flex flex-column justify-content-between dashboard-card"
            >
              <img [src]="card.image" class="image" />
              <div class="dashboard-card-content">
                <div>{{ card.title }}</div>
              </div>
            </div>
          </app-card>
        </app-grid-tile>
      </app-grid-list>
    </ng-template>
  </div>
  <!-- Content Main -->
</app-container-header>
